module.exports = __webpack_public_path__ + "img/login.0e1e0621.png";